import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Field — shared form-label-wrapper für team-route + settings-route.
 *
 * Layout: vertikal-stack, label oben (font-medium neutral-700), input/select
 * darunter, ggf. error darunter (text-danger, role="alert"). Optionaler
 * className extendet den `<label>`-wrapper (z.B. `hidden`-conditional).
 *
 * Bewusst KEIN htmlFor/id-pair: die children-inputs sind via `<label>`
 * parent-wrapper bereits semantisch verbunden (implicit-association,
 * WCAG-konform). Erspart props-drilling für ids.
 */
export interface FieldProps {
  label: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export function Field({ label, error, children, className }: FieldProps): React.ReactElement {
  return (
    <label className={cn("flex flex-col gap-1 text-sm", className)}>
      <span className="font-medium text-[color:var(--color-text-secondary)]">{label}</span>
      {children}
      {error && (
        <span role="alert" className="text-xs text-[color:var(--color-danger)]">
          {error}
        </span>
      )}
    </label>
  );
}

Field.displayName = "Field";
